import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { TableHeaderCellProvider } from '../TableHeaderCell/TableHeaderCell.context';
import { StyledTableHeader } from './TableHeader.styles';

/**
 * A native [`<thead>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/thead) element.
 *
 * @since 8.0.0
 */
export var TableHeader = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(TableHeaderCellProvider, {
    value: {
      parent: 'header'
    }
  }, /*#__PURE__*/React.createElement(StyledTableHeader, _extends({
    ref: forwardedRef
  }, props)));
});
TableHeader.displayName = 'Table.Header';
TableHeader.propTypes = {
  /**
   * Background style of the table header.
   */
  appearance: PropTypes.oneOf(['light', 'dark'])
};
TableHeader.defaultProps = {
  appearance: 'light'
};